import { Button, Input } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { downloadInvoice, eInvoiceEdit, eInvoiceStatusUpdate } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import Download from "src/assets/Download.svg"
import { useState } from "react";

import { useEventStatus } from "src/hooks/useEventStatus";

const EwayDetails = ({
    onCloseModal,
    invoiceData,
    onSuccess,
}: {
    onCloseModal: () => void;
    invoiceData: any;
    onSuccess: () => void;
}) => {
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [ewayBillNumber, setEwayBillNumber] = useState<string>("");
    const [ewayBillDate, setEwayBillDate] = useState<string>("");
    const [ewayBillAmount, setEwayBillAmount] = useState<string>("");
    const [irnNumber, setIrnNumber] = useState<string>("");
    const [remarks, setRemarks] = useState<string>("");
    // const eInvIRN = invoiceData?.einvoiceDtl?.irn_number;
    // const [ewayBillExempt, setEwayBillExempt] = useState<string>("");
    const company_code = invoiceData?.company_code;

    const { withEventCheck } = useEventStatus();

    const handleEwayDetailsSubmit = async () => {
        if (!ewayBillNumber || !ewayBillDate || !ewayBillAmount || !irnNumber) {
            toast({ description: "Please fill all the fields", variant: "destructive" });
            return;
        }
        if (ewayBillNumber.length > 12) {
            toast({ description: "E-Way Bill Number should be a 12 digit number", variant: "destructive" });
            return;
        }
        if (irnNumber?.trim().length !== 64) {
            toast({ description: "IRN Number should be a 64 character", variant: "destructive" });
            return;
        }
        // if (invoiceData?.einvoiceDtl?.einvoice_status === "accepted" && eInvIRN?.trim() !== irnNumber.trim() && eInvIRN?.trim() !== "" && eInvIRN?.trim() !== null && eInvIRN?.trim() !== undefined) {
        //     toast({ description: "IRN Number should be same as E-Invoice IRN", variant: "destructive" });
        //     return;
        // }
        setIsLoading(true);
        const payload = {
            "data":
            {
                "einvoice_dtl_id": invoiceData?.eWayBillDtl?.einvoice_dtl_id,
                "einvoice_status": invoiceData?.eWayBillDtl?.einvoice_status,
                // invoice DTL
                "invoice_number": ewayBillNumber,
                "irn_number": irnNumber,
                "amount": ewayBillAmount,
                "einvoice_ref_type": "IRN",
                "invoice_date": invoiceData?.eWayBillDtl?.invoice_date,
                "irn_date": ewayBillDate,
                "buyer_gst": invoiceData?.eWayBillDtl?.buyer_gst,
                "seller_gst": invoiceData?.eWayBillDtl?.seller_gst,
                "hsncode": invoiceData?.eWayBillDtl?.hsncode,
                "item_count": invoiceData?.eWayBillDtl?.item_count
            }
            ,
            "primary_key": invoiceData?.stockist_invoice_attachment_id,
            "event_type": "E_INVOICE_EDIT"
        }
        const payload2 = {
            data: {
                einvoice_dtl_id: invoiceData?.eWayBillDtl?.einvoice_dtl_id,
                einvoice_status: "accepted",
                remarks: remarks || "-",
                reason: "other",
                mapped_fuid_number: invoiceData?.eWayBillDtl?.mapped_fuid_number,
                irn_number: invoiceData?.eWayBillDtl?.irn_number,
                attachment_type: "eway",
            },
            primary_key: invoiceData?.stockist_invoice_attachment_id,
            event_type: "E_INVOICE_STATUS_UPDATE",
        };
        try {
            const response = await eInvoiceEdit(payload);
            let response2: any;

            const invoiceStatusUpdateResponse = await withEventCheck(
                async () => {
                    response2 = await eInvoiceStatusUpdate(payload2);
                },
                response?.data?.data?.eventStreamCreated?.streamId
            );
            const invoiceStatusUpdateRespons2 = await withEventCheck(
                async () => {
                    console.log("updated");
                },
                response2?.data?.data?.eventStreamCreated?.streamId
            );
            toast({ description: "Eway details updated successfully", variant: "default" });
            onCloseModal();

            console.log("invoiceStatusUpdateResponse", invoiceStatusUpdateResponse);
            console.log("invoiceStatusUpdateRespons2", invoiceStatusUpdateRespons2);
            onSuccess();
        } catch (error: any) {
            console.log(error);
            toast({ description: error?.response?.data?.message, variant: "destructive" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-y-2 w-[400px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Verify Eway Details</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <div className="flex flex-col gap-y-2 px-2">
                <div className="mb-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">E-Way Bill Number</label>
                    <Input
                        enableArrows={false}
                        showIcon={false}
                        type="number"
                        placeholder="E-Way Bill Number"
                        value={ewayBillNumber}
                        onChange={(e: any) => setEwayBillNumber(e?.target?.value)}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                        isError={ewayBillNumber.length > 12}
                        errorMessage="E-Way Bill Number should be a 12 digit number"
                    />
                </div>
                <div className="mt-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">E-Way Bill Date</label>
                    <Input
                        enableArrows={false}
                        showIcon={false}
                        type="date"
                        placeholder="E-Way Bill Date"
                        value={ewayBillDate ? ewayBillDate.split("T")[0] : ""}
                        onChange={(e: any) => {
                            const dateValue = e.target.value;
                            const selectedDate = new Date(dateValue);

                            const now = new Date();

                            // Set time using UTC values
                            selectedDate.setUTCHours(now.getUTCHours());
                            selectedDate.setUTCMinutes(now.getUTCMinutes());
                            selectedDate.setUTCSeconds(now.getUTCSeconds());
                            selectedDate.setUTCMilliseconds(now.getUTCMilliseconds());

                            const formattedDate = selectedDate.toISOString(); // This will be in UTC
                            setEwayBillDate(formattedDate);
                        }}
                        max={new Date().toISOString().split("T")[0]}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                    />
                </div>
                <div className="mt-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">E-Way Bill Amount</label>
                    <Input
                        enableArrows={false}
                        showIcon={false}
                        type="number"
                        placeholder="E-Way Bill Amount"
                        value={ewayBillAmount}
                        onChange={(e: any) => setEwayBillAmount(e?.target?.value)}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                    />
                </div>
                <div className="mt-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">IRN Number</label>
                    <Input
                        enableArrows={false}
                        showIcon={false}
                        type="text"
                        placeholder="IRN Number"
                        value={irnNumber}
                        onChange={(e: any) => setIrnNumber(e?.target?.value)}
                        className="w-full py-1  border border-gray-300 rounded-lg"
                        isError={irnNumber?.trim() !== "" && irnNumber?.trim().length !== 64}
                        errorMessage="IRN Number should be exactly 64 characters"

                    />
                </div>
                <div className="mt-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">Remarks</label>
                    <Input
                        enableArrows={false}
                        showIcon={false}
                        type="text"
                        placeholder="Remarks"
                        value={remarks}
                        onChange={(e: any) => setRemarks(e?.target?.value)}
                        className="w-full py-1 border border-gray-300 rounded-lg"
                    />
                </div>
                <div className="flex justify-end mt-2">
                    <Button
                        onClick={() => {
                            if (!invoiceData?.eway_attachment_path) {
                                toast({ description: "E-Way Bill not found", variant: "destructive" });
                                return;
                            }
                            downloadInvoice(invoiceData?.eway_attachment_path, company_code).then((res: any) => {
                                if (res?.data?.success && res?.data?.data) {
                                    window.open(res?.data?.data, "_blank");
                                } else {
                                    console.error("Failed to download the invoice.");
                                }
                            });
                        }}
                        className="font-normal text-[#1B1A1F] border-[#6a6a6a] border-[1px]">
                        <img src={Download} alt="download" className="w-5 h-5 mr-2" />
                        Download Eway Bill</Button>
                </div>
                {/* <div className="mt-2">
                    <label className="text-sm mb-2 font-normal text-[#666666]">E-Way Bill Exempt</label>
                    <Autocomplete
                        placeholder="Select E-Way Bill Exempt"
                        suggestionList={[{ key: "Yes", value: "Yes" }, { key: "No", value: "No" }]}
                        displayKey="value"
                        uniqueKey="key"
                        onSelectionChange={(e: any) => setEwayBillExempt(e?.key)}
                    />
                </div> */}
            </div>

            <div className="gap-x-2">
                <Button isLoading={isLoading} loaderSize="small" disabled={isLoading} className="text-white w-full bg-[#8051FF] mt-4" onClick={handleEwayDetailsSubmit}>
                    Proceed
                </Button>
                {/* <Button disabled={isLoading} className="bg-[#f5f5f5]  mt-4" onClick={onCloseModal}>
                    Cancel
                </Button> */}
            </div>
        </div >
    );
};

export default EwayDetails;
